// src/components/PublicRoute.tsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const token =
    sessionStorage.getItem("access_token") ||
    localStorage.getItem("access_token");

  if (token) {
    // Already logged in → redirect to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;



